import React, { useState, useEffect } from 'react';
import Header from '../../layouts/Header';
import { Badge, Button, Col, Form, Image, Modal, Pagination, Row, Spinner, Table } from 'react-bootstrap';
import { CheckCircleFill, ClockFill, GeoAltFill, PlusCircle, Trash, XCircleFill } from 'react-bootstrap-icons';
import Select from 'react-select';
import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';

const UniMenuAddon = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);

    const accessToken = localStorage.getItem('authToken');
    const [openAddModal, setOpenAddModal] = useState(false);
    const [iconsList, setIconsList] = useState([]);
    const [formData, setFormData] = useState({
        title: '',
        values: [{ sequenceNumber: 1, value: '', icon: '' }],
    });

    // This would typically come from your API or context
    const [outlets, setOutlets] = useState([]);
    const [selectedExOutlets, setSelectedExOutlets] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [addonsList, setAddonsList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [productAddonId, setProductAddonId] = useState('');
    const [openEditModal, setOpenEditModal] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [editSelectedExOutlet, setEditSelectedExOutlet] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    // State for pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);

    // Calculate indexes for slicing data
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = addonsList?.slice(indexOfFirstRecord, indexOfLastRecord);

    const StatusBadge = ({ status }) => {
        return status === 'ACTIVE' ? (
            <Badge bg="success" className="d-flex align-items-center">
                <CheckCircleFill className="me-1" size={12} />
                Active
            </Badge>
        ) : (
            <Badge bg="secondary" className="d-flex align-items-center py-1">
                <XCircleFill className="me-1" size={12} />
                Inactive
            </Badge>
        );
    };

    const getAddonsList = async() => {
        setIsLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const response = await axiosInstance.get("addons", {headers});
            console.log("Addons Data :", response?.data?.data);
            setAddonsList(response?.data?.data?.addons);
            setFilteredData(response?.data?.data?.addons);
        } catch (error) {
            console.log("Error :", error);
            
        } finally {
            setIsLoading(false);
        }
    }

    const getOutlets = async () => {
        try {
            const headers = {
            Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("outlet", { headers });
    
            if (response?.data?.status === true) {
                let filteredOutlets = response?.data?.data?.outlets?.filter((act) => act?.status === "ACTIVE");
                setOutlets(filteredOutlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
            }
        }
    };

    const outletData = outlets?.map((outlet) => ({
        value: outlet._id,
        label: `${outlet.name} (${outlet.city})`,
    }));

    const getIconsList = async () => {
        try {
        const headers = {
            Authorization: `Bearer ${accessToken}`,
        };
        const response = await axiosInstance.get("product-addon/getAddonIcons", {
            headers,
        });
        if (response?.data?.status === true) {
            const addOnIcons = response?.data?.data?.addonIcons;
            setIconsList(addOnIcons);
        }
        } catch (error) {
        if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
            });
        }
        }
    };

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
    }

    const handleCloseAddModal = () => {
        setOpenAddModal(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleValueChange = (index, e) => {
        const { name, value } = e.target;
        const updatedValues = [...formData.values];
        updatedValues[index] = { ...updatedValues[index], [name]: value };
        setFormData(prev => ({ ...prev, values: updatedValues }));
    };

    const addValueField = () => {
        const nextSequence = formData?.values.length > 0 
        ? Math.max(...formData?.values?.map(v => v.sequenceNumber)) + 1 
        : 1;
        setFormData(prev => ({
        ...prev,
        values: [...prev.values, { sequenceNumber: nextSequence, value: '', icon: '' }]
        }));
    };

    const addEditValueField = () => {
        const nextSequence = editedData?.values.length > 0 
        ? Math.max(...editedData?.values?.map(v => v.sequenceNumber)) + 1 
        : 1;
        setEditedData(prev => ({
        ...prev,
        values: [...prev.values, { sequenceNumber: nextSequence, value: '', icon: '' }]
        }));
    };

    const removeValueField = (index) => {
        if (formData?.values?.length <= 1) return;
        const updatedValues = formData?.values?.filter((_, i) => i !== index);
        setFormData(prev => ({ ...prev, values: updatedValues }));
    };

    const removeEditValueField = (index) => {
        if (editedData?.values?.length <= 1) return;
        const updatedValues = editedData?.values?.filter((_, i) => i !== index);
        setEditedData(prev => ({ ...prev, values: updatedValues }));
    };

    const handleExcludedOutletsChange = (selectedOptions) => {
        setSelectedExOutlets(selectedOptions);
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        setIsAddBtnLoading(true);

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            let selectedTitleExcOutlets = selectedExOutlets?.map((ex) => ex?.value);

            const removeEmptyFields = (obj) => {
                return Object.fromEntries(
                Object.entries(obj).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
                );
            };
      
            // Function to check if an addonValue object is empty after cleaning
            const isEmptyAddonValue = (obj) => {
                return Object.keys(removeEmptyFields(obj)).length === 0;
            };

            // Add excludedOutlets to each addonValue if it's not empty
            const cleanedAddonValues = formData.values
                .map((addonValue) => {
                    const cleanedValue = removeEmptyFields(addonValue);
                    return cleanedValue;
                })
                .filter((value) => !isEmptyAddonValue(value));
      
            // Clean main inputData and add excludedOutlets if it's not empty
            const cleanedInputData = {
                ...removeEmptyFields({ ...formData, values: undefined, addonValues: undefined }), // Explicitly remove 'values' and 'addonValues'
                ...(selectedTitleExcOutlets?.length > 0 && { excludedOutlets: selectedTitleExcOutlets }),
                values: cleanedAddonValues, // Only sending 'value'
            };

            const response = await axiosInstance.post('addons', cleanedInputData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                // getAddonProductsList(categoryId, page, limit, productId, searchText);
        
                setFormData({
                    // product: "",
                    addonTitle: "",
                    // isMultipleSelect: "",
                    addonValues: Array.from({ length: 1 }, () => ({
                        value: "",
                        // mrp: "",
                        // offerPrice: "",
                        sequenceNumber: "",
                        icon: "",
                        // isDefault: false,
                        // subLabel: "",
                        // status: "INACTIVE",
                    })),
                });
        
                setSelectedExOutlets([]);
                setOpenAddModal(false);
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                if (error.response?.status === 406) {
                errorMessage =
                    error?.response?.data?.error?.message ||
                    error?.response?.data?.error;
                } else if (error.response?.status === 412) {
                errorMessage =
                    error?.response?.data?.data?.message ||
                    error?.response?.data?.error;
                } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error;
                }
        
                toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
                });
            }
        } finally {
            setIsAddBtnLoading(false);
        }
    };

    const handleOpenEditModal = (data) => {
        console.log("Edited Data :", data);
        setOpenEditModal(true);
        setEditedData({
            _id: data._id,
            title: data.title || '',
            isMultiSelect: data.isMultipleSelect || false,
            // excludedOutlets: data.excludedOutlets?.map(outlet => ({
            //     label: outlet.name,
            //     value: outlet._id
            // })) || [],
            addonValues: data.addonValues?.map(value => ({
                sequenceNumber: value.sequenceNumber || 1,
                value: value.value || '',
                icon: value.icon || '',
                status: value.status,
                _id: value._id || null,
            })) || [],
        })
        let selectedExcluded = data?.excludedOutlets?.map((outlet) => ({
                label: outlet?.name,
                value: outlet._id
            }) 
        )
        setEditSelectedExOutlet(selectedExcluded);
    };

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
    };

    const handleEditExcludedOutletsChange = (selected) => {
        setEditSelectedExOutlet(selected);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditedData(prev => ({ ...prev, [name]: value }));
    };

    const handleEditValueChange = (index, e) => {
        const { name, value } = e.target;
        const updatedValues = [...editedData.values];
        updatedValues[index] = { ...updatedValues[index], [name]: value };
        setEditedData(prev => ({ ...prev, values: updatedValues }));
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsEditBtnLoading(true);
    
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
    
            let selectedExoutlet = editSelectedExOutlet?.map((ex) => ex?.value) || [];
    
            const data = {
                _id: editedData._id,
                addonTitle: editedData.title, // Fixed inconsistency
                addonSerialNumber: editedData?.addonSerialNumber || 1,
                product: editedData?.product || null,
                isMultipleSelect: editedData?.isMultiSelect || false,
                excludedOutlets: selectedExoutlet,
                addonValues: editedData?.addonValues?.map((value) => ({
                    value: value.value || '',
                    _id: value._id || null,
                    isDefault: value?.isDefault || false,
                    isMultipleSelect: editedData?.isMultiSelect || false,
                    sequenceNumber: value.sequenceNumber || 1,
                    icon: value.icon || '',
                    status: value?.status || "active", 
                })) || []
            };
    
            // Clean up data by removing empty/null fields
            const cleanedData = {
                ...data,
                addonValues: data?.addonValues?.map(valueObj =>
                    Object.fromEntries(
                        Object.entries(valueObj).filter(
                            ([key, v]) =>
                                key === "mrp" ||
                                key === "offerPrice" ||
                                (key === "subLabel" ? v !== null : v !== "" && v !== undefined) 
                        )
                    )
                )
            };
    
            const response = await axiosInstance.put("addons", cleanedData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getAddonsList();
                setOpenEditModal(false);
            }
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getAddonsList();
                setOpenEditModal(false);
                setEditedData({});
            }
        } catch (error) {
            let errorMessage = "An unexpected error occurred.";
            
            if (error.response) {
                const { status, data } = error.response;
                if (status === 406) {
                    errorMessage = data?.error?.message || data?.error || data?.message;
                } else if (status === 412) {
                    errorMessage = data?.data?.message || data?.error;
                } else if (status === 500) {
                    errorMessage = data?.error || "Internal Server Error.";
                }
            }
    
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
            });
        } finally {
            setIsEditBtnLoading(false);
        }
    };
    
    const handleOpenDeleteModal = (data) => {
        setProductAddonId(data?._id);
        setOpenDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };

    const handleDeleteAddon = async(e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const data = {
                _id: productAddonId,
            };
    
            const response = await axiosInstance.delete(`addons`, {
                data,
                headers,
            });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getAddonsList();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = '';
                // error.response.data.error
                if (error.response?.status === 406) {
                    errorMessage =
                        error?.response?.data?.error?.message ||
                        error?.response?.data?.error;
                    } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message ||
                        error?.response?.data?.error;
                    } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    // Function to handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Function to handle records per page change
    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    }

    // Generate pagination items
    const totalPages = Math.ceil(addonsList?.length / recordsPerPage);
    const paginationItems = [];
    for (let number = 1; number <= totalPages; number++) {
        paginationItems.push(
            <Pagination.Item key={number} active={number === currentPage} onClick={() => handlePageChange(number)}>
                {number}
            </Pagination.Item>
        );
    }

    useEffect(() => {
        getIconsList();
        getOutlets();
        getAddonsList();
    }, []);

    useEffect(() => {
            const result = addonsList?.filter((item) => {
              return item.title.toLowerCase().match(searchText.toLocaleLowerCase());
            });
            setFilteredData(result);
        }, [searchText]);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
                <div className="main main-app p-3 p-lg-4">
                    <div
                        className="container shadow-sm"
                        style={{ backgroundColor: "white" }}
                    >
                        <Row className="pt-4">
                            <Col>
                                <h5 className="fw-semibold">UNIVERSAL MENU ADDONS MANAGEMENT</h5>
                            </Col>
                            <hr />
                        </Row>

                        <Row>
                            <Col>
                                <div className="input-group w-100">
                                    <input
                                        type="text"
                                        value={searchText}
                                        onChange={handleSearchChange}
                                        className="form-control"
                                        placeholder="Search by addon title..."
                                    />
                                    <button className="btn btn-primary" type="button">
                                        { isSearchLoading ? <Spinner size='sm' /> : <>  <i className="ri-search-line"></i> </> }
                                    </button>
                                </div>
                            </Col>
                            <Col></Col>
                            <Col></Col>
                            <Col lg="3" className="d-flex justify-content-end flex-column">
                                <Button
                                    variant="primary"
                                    className="fw-semibold"
                                    onClick={handleOpenAddModal}
                                >
                                    <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                    Add New Addon
                                </Button>
                            </Col>
                        </Row>

                        <Row className="mt-4">
                            <Col>
                                {/* Top Controls */}
                                <Row className="mt-1 mb-2">
                                    <Col className="d-flex justify-content-end align-items-center gap-2">
                                        <Form.Group controlId="recordsPerPage" className="d-flex align-items-center">
                                            <Form.Label className="mb-0 fw-semibold">Rows per page:</Form.Label>
                                            <Form.Select size="sm" className="w-50 ms-1" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                            </Form.Select>
                                        </Form.Group>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(1)}
                                        >
                                            « First
                                        </Button>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        >
                                            ‹ Prev
                                        </Button>
                                        <span className="fw-semibold">{currentPage} / {totalPages}</span>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        >
                                            Next ›
                                        </Button>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange(totalPages)}
                                        >
                                            Last »
                                        </Button>
                                    </Col>
                                </Row>

                                <Table hover responsive bordered className="mb-0 align-middle shadow-sm">
                                    <thead className="bg-primary text-white">
                                        <tr>
                                            <th width="5%">#</th>
                                            <th width="20%">Title</th>
                                            <th width="25%">Values</th>
                                            <th width="25%">Excluded Outlets</th>
                                            <th width="10%">Status</th>
                                            <th width="10%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData?.map((addon, index) => (
                                            <tr key={addon._id}>
                                                {/* Row Number */}
                                                <td className="text-muted text-center">{index + 1}</td>

                                                {/* Title & Sequence Info */}
                                                <td>
                                                    <div className="d-flex flex-column">
                                                        <div className="fw-semibold text-primary mb-1 d-flex align-items-center">
                                                            <span className="text-truncate" style={{ maxWidth: '200px' }} title={addon.title}>
                                                                {addon.title}
                                                            </span>
                                                            {addon.isMultipleSelect && (
                                                                <span className="badge bg-info bg-opacity-10 text-info ms-2 fs-7 fw-normal">
                                                                    Multi-select
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="d-flex align-items-center mt-1">
                                                            <span className="badge bg-light text-dark d-flex align-items-center fs-7">
                                                                <i className="me-1">Sequence No</i>
                                                                <span>{addon.sequenceNumber}</span>
                                                            </span>
                                                            {addon.isDelete && (
                                                                <span className="badge bg-danger bg-opacity-10 text-danger ms-2 fs-7">
                                                                    <i className="bi bi-trash me-1"></i>
                                                                    Deletable
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* Values List */}
                                                <td>
                                                    <div className="d-flex flex-column gap-2">
                                                        {addon?.addonValues?.map((val, i) => (
                                                            <div
                                                                key={i}
                                                                className="d-flex align-items-center p-2 bg-light rounded shadow-sm"
                                                                style={{
                                                                    borderLeft: `4px solid ${val.status === 'ACTIVE' ? '#28a745' : '#6c757d'}`,
                                                                }}
                                                            >
                                                                <span
                                                                    className="badge bg-white text-primary fw-bold me-3 d-flex justify-content-center align-items-center"
                                                                    style={{
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        borderRadius: '50%',
                                                                        border: '1px solid #dee2e6',
                                                                    }}
                                                                >
                                                                    {val.sequenceNumber}
                                                                </span>
                                                                <div className="flex-grow-1">
                                                                    <div className="fw-semibold text-dark">{val.value}</div>
                                                                    {val.icon && (
                                                                        <small className="text-muted d-block mt-1">
                                                                            <i className="bi bi-image me-1"></i>
                                                                            Has Icon
                                                                        </small>
                                                                    )}
                                                                </div>
                                                                <div className="ms-auto">
                                                                    <StatusBadge status={val.status} />
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>

                                                {/* Excluded Outlets */}
                                                <td>
                                                    <div className="d-flex flex-wrap gap-2">
                                                        {addon?.excludedOutlets?.map((outlet, i) => (
                                                            <Badge key={i} bg="secondary" className="fw-normal text-white px-2 py-1">
                                                                {outlet.name || `Outlet ${i + 1}`}
                                                            </Badge>
                                                        ))}
                                                    </div>
                                                </td>

                                                {/* Status */}
                                                <td className="text-center">
                                                    <StatusBadge status={addon.status} />
                                                </td>

                                                {/* Actions */}
                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center gap-2">
                                                        <button
                                                            className="btn btn-sm btn-outline-primary px-3 py-1"
                                                            onClick={() => handleOpenEditModal(addon)}
                                                        >
                                                            <i className="bi bi-pencil"></i> Edit
                                                        </button>
                                                        <button
                                                            className="btn btn-sm btn-outline-danger px-3 py-1"
                                                            onClick={() => handleOpenDeleteModal(addon)}
                                                        >
                                                            <i className="bi bi-trash"></i> Delete
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                {/* Pagination Controls */}
                                {/* Pagination Controls */}
                                <Row className="mt-3 mb-2">
                                    <Col className="d-flex justify-content-end align-items-center gap-2">
                                        <Form.Group controlId="recordsPerPage" className="d-flex align-items-center">
                                            <Form.Label className="mb-0 fw-semibold">Rows per page:</Form.Label>
                                            <Form.Select size="sm" className="w-50 ms-1" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                            </Form.Select>
                                        </Form.Group>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(1)}
                                        >
                                            « First
                                        </Button>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        >
                                            ‹ Prev
                                        </Button>
                                        <span className="fw-semibold">{currentPage} / {totalPages}</span>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        >
                                            Next ›
                                        </Button>
                                        <Button
                                            variant="light"
                                            size="sm"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange(totalPages)}
                                        >
                                            Last »
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>


                        {openAddModal ? (
                            <Modal show={openAddModal} onHide={handleCloseAddModal} size="lg" centered>
                                <Modal.Header closeButton className="bg-light">
                                    <Modal.Title>Add New Addon</Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleSubmit}>
                                    <Modal.Body>
                                        <Form.Group className="mb-4">
                                            <Form.Label className='fw-semibold'>Addon Title <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                placeholder="Enter addon title"
                                                required
                                            />
                                        </Form.Group>
                                        <hr />

                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                            <Form.Label className="mb-0 fw-bold">Addon Values</Form.Label>
                                            <Button 
                                                variant="outline-primary" 
                                                size="sm" 
                                                onClick={addValueField}
                                            >
                                                <PlusCircle className="me-1" /> Add Value
                                            </Button>
                                            </div>
                                            
                                            {formData?.values?.map((item, index) => (
                                            <Row key={index} className="mb-3 g-2 align-items-center">
                                                <Col md={2}>
                                                    <Form.Label className='fw-semibold'>Seq No. <span className='text-danger'>*</span></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="sequenceNumber"
                                                        value={item.sequenceNumber}
                                                        onChange={(e) => handleValueChange(index, e)}
                                                        min="1"
                                                        required
                                                    />
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Label className='fw-semibold'>Addon Value Name <span className='text-danger'>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="value"
                                                        value={item.value}
                                                        onChange={(e) => handleValueChange(index, e)}
                                                        placeholder="Addon Value Name"
                                                        required
                                                    />
                                                </Col>
                                                <Col md={4}>
                                                    <Form.Label className='fw-semibold'>Addon Value Icon <span className='text-danger'>*</span></Form.Label>
                                                    <Form.Select
                                                        name="icon"
                                                        onChange={(e) => handleValueChange(index, e)}
                                                        value={item.icon}
                                                    >
                                                        <option value="">Select Addon Icon</option>
                                                        {iconsList?.map((rm) => (
                                                            <option key={rm._id} value={rm._id}>
                                                                {rm.name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                                <Col md={2}>
                                                    <Row>
                                                        <Form.Label className='text-white'>.</Form.Label>
                                                    </Row>
                                                    <Button 
                                                        variant="outline-danger" 
                                                        onClick={() => removeValueField(index)}
                                                        disabled={formData?.value?.length <= 1}
                                                    >
                                                        <Trash />
                                                    </Button>
                                                </Col>
                                            </Row>
                                            ))}
                                        </div>

                                        <hr />
                                        <Form.Group className="mb-4">
                                            <Form.Label className='fw-semibold'>Excluded Outlets</Form.Label>
                                            <Select
                                                isMulti
                                                options={outletData}
                                                value={selectedExOutlets}
                                                onChange={handleExcludedOutletsChange}
                                                placeholder="Select outlets to exclude..."
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                closeMenuOnSelect={false}
                                            />
                                        </Form.Group>
                                    </Modal.Body>
                                    <Modal.Footer className="bg-light">
                                        <Button variant="secondary" onClick={handleCloseAddModal}>
                                            Cancel
                                        </Button>
                                        <Button variant="primary" type="submit">
                                            { isAddBtnLoading ? <Spinner size='sm' /> : "Save Addon" }
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        ) : null}

                        {openEditModal ? (
                            <Modal show={openEditModal} onHide={handleCloseEditModal} size="lg" centered>
                                <Modal.Header closeButton className="bg-light">
                                    <Modal.Title>Add New Addon</Modal.Title>
                                </Modal.Header>
                                <Form onSubmit={handleEditSubmit}>
                                    <Modal.Body>
                                        {/* Addon Title */}
                                        <Row className="mb-4">
                                            <Col>
                                                <Form.Label className='fw-semibold'>
                                                    Addon Title <span className='text-danger'>*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="title"
                                                    value={editedData.title}
                                                    onChange={handleEditChange}
                                                    placeholder="Enter addon title"
                                                    required
                                                />
                                            </Col>
                                            <Col>
                                                <Form.Label className='fw-semibold'>Multi-Select Option <span className='text-danger'>*</span></Form.Label>
                                                <Form.Select
                                                    name="isMultiSelect"
                                                    value={editedData.isMultiSelect ? "true" : "false"}
                                                    onChange={(e) => handleEditChange({ 
                                                        target: { 
                                                            name: "isMultiSelect", 
                                                            value: e.target.value === "true" 
                                                        } 
                                                    })}
                                                >
                                                    <option value="true">Yes</option>
                                                    <option value="false">No</option>
                                                </Form.Select>
                                            </Col>
                                        </Row>

                                        <hr />

                                        {/* Addon Values */}
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <Form.Label className="mb-0 fw-bold">Addon Values</Form.Label>
                                                <Button 
                                                    variant="outline-primary" 
                                                    size="sm" 
                                                    onClick={addEditValueField}
                                                >
                                                    <PlusCircle className="me-1" /> Add Value
                                                </Button>
                                            </div>

                                            {editedData?.values?.map((item, index) => (
                                                <Row key={index} className="mb-3 g-2 align-items-center">
                                                    <Col md={2}>
                                                        <Form.Label className='fw-semibold'>
                                                            Seq No. <span className='text-danger'>*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="sequenceNumber"
                                                            value={item.sequenceNumber}
                                                            onChange={(e) => handleEditValueChange(index, e)}
                                                            min="1"
                                                            required
                                                        />
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Label className='fw-semibold'>
                                                            Addon Value Name <span className='text-danger'>*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="value"
                                                            value={item.value}
                                                            onChange={(e) => handleEditValueChange(index, e)}
                                                            placeholder="Addon Value Name"
                                                            required
                                                        />
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Label className='fw-semibold'>
                                                            Addon Value Icon <span className='text-danger'>*</span>
                                                        </Form.Label>
                                                        <Form.Select
                                                            name="icon"
                                                            onChange={(e) => handleEditValueChange(index, e)}
                                                            value={item.icon}
                                                        >
                                                            <option value="">Select Addon Icon</option>
                                                            {iconsList?.map((rm) => (
                                                                <option key={rm._id} value={rm._id}>
                                                                    {rm.name}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Label className='fw-semibold'>
                                                            Status <span className='text-danger'>*</span>
                                                        </Form.Label>
                                                        <Form.Select
                                                            name="status"
                                                            onChange={(e) => handleEditValueChange(index, e)}
                                                            value={item.status}
                                                            required
                                                        >
                                                            <option value="ACTIVE">ACTIVE</option>
                                                            <option value="INACTIVE">INACTIVE</option>
                                                        </Form.Select>
                                                    </Col>
                                                    <Col md={1}>
                                                        <Row>
                                                            <Form.Label className='text-white'>.</Form.Label>
                                                        </Row>
                                                        <Button 
                                                            variant="outline-danger" 
                                                            onClick={() => removeEditValueField(index)}
                                                            disabled={editedData?.values?.length <= 1}
                                                        >
                                                            <Trash />
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            ))}
                                        </div>

                                        <hr />

                                        {/* Excluded Outlets */}
                                        <Form.Group className="mb-4">
                                            <Form.Label className='fw-semibold'>Excluded Outlets</Form.Label>
                                            <Select
                                                isMulti
                                                options={outletData}
                                                value={editSelectedExOutlet}
                                                onChange={handleEditExcludedOutletsChange}
                                                placeholder="Select outlets to exclude..."
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                closeMenuOnSelect={false}
                                            />
                                        </Form.Group>
                                    </Modal.Body>

                                    <Modal.Footer className="bg-light">
                                        <Button variant="secondary" onClick={handleCloseAddModal}>
                                            Cancel
                                        </Button>
                                        <Button variant="primary" type="submit">
                                            {isEditBtnLoading ? <Spinner size='sm' /> : "Save Addon"}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        ) : null}

                        {openDeleteModal ? (
                            <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirm Delete</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Are you sure you want to delete this Addon? This action cannot be undone.
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setOpenDeleteModal(false)}>
                                        Cancel
                                    </Button>
                                    <Button variant="danger" onClick={handleDeleteAddon}>
                                        { isDeleteBtnLoading ?
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            /> :
                                            "Delete Addon"                                
                                        }
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        ) : null}
                    </div>
                </div>
        </React.Fragment>
    )
}

export default UniMenuAddon